module.exports = __webpack_public_path__ + "3b95a2fde4ec862a0b8bb4f71988d425.MP3";